import Main from '@/components/main'
const ftsMenusRouters = [
  {
    name: 'ftsBaseData',
    path: '/ftsBaseData',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '基础数据',
      icon: 'ios-albums',
      access: ['ftsBaseData']
    },
    component: Main,
    children: [{
      name: 'fts_base_farm',
      path: 'fts_base_farm',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '基地管理',
        icon: 'md-square',
        access: ['fts_base_farm']
      },
      component: () => import('@/view/fts/base/farm/farm-index.vue')
    }, {
      name: 'base-input',
      path: 'base-input',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '投入品信息',
        icon: 'ios-square',
        access: ['base-input']
      },
      component: () => import('@/view/fts/base/inputs/inputs-index.vue')
    }, {
      name: 'base-material',
      path: 'base-material',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '原料管理',
        icon: 'ios-square',
        access: ['base-material']
      },
      component: () => import('@/view/fts/base/material/material-index.vue')
    }, {
      name: 'fts_base_supplier',
      path: 'fts_base_supplier',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '供应商管理',
        icon: 'md-square',
        access: ['fts_base_supplier']
      },
      component: () => import('@/view/fts/base/supplier/supplier-index.vue')
    }, {
      name: 'fts_base_product_brand',
      path: 'fts_base_product_brand',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '品牌信息',
        icon: 'md-square',
        access: ['fts_base_product_brand']
      },
      component: () => import('@/view/fts/base/product-brand/product-brand-index.vue')
    }, {
      name: 'fts-product-category',
      path: 'fts-product-category',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '产品类目管理',
        icon: 'md-square',
        access: ['fts-product-category']
      },
      component: () => import('@/view/fts/base/product-category/product-category-list.vue')
    }, {
      name: 'fts-product-category-ent',
      path: 'fts-product-category-ent',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '产品类目管理',
        icon: 'md-square',
        access: ['fts-product-category-ent']
      },
      component: () => import('@/view/fts/base/product-category/product-category-ent-list.vue')
    }, {
      name: 'fts_base_product',
      path: 'fts_base_product',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '产品信息',
        icon: 'md-square',
        access: ['fts_base_product']
      },
      component: () => import('@/view/fts/base/product/product-index.vue')
    }, {
      name: 'fts_base_customer',
      path: 'fts_base_customer',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '客户管理',
        icon: 'md-easel',
        access: ['fts_base_customer']
      },
      component: () => import('@/view/fts/base/customer/customer-index.vue')
    }, {
      name: 'fts_base_processStep',
      path: 'fts_base_processStep',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '加工步骤',
        icon: 'md-square',
        access: ['fts_base_processStep']
      },
      component: () => import('@/view/fts/trace-setting/process/process-step-index.vue')
    }]
  },
  {
    name: 'fts_oper',
    path: '/fts_oper',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '生产档案',
      icon: 'ios-clipboard',
      access: ['fts_oper']
    },
    component: Main,
    children: [{
      name: 'fts_oper_production',
      path: 'fts_oper_production',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '生产批次',
        icon: 'md-square',
        access: ['fts_oper_production']
      },
      component: () => import('@/view/fts/oper/production/production-index.vue')
    }, {
      name: 'oper_process',
      path: 'oper_process',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '加工管理',
        icon: 'md-square',
        access: ['oper_process']
      },
      component: () => import('@/view/fts/oper/process/process-index.vue')
    }, {
      name: 'fts_oper_pack',
      path: 'fts_oper_pack',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '包装管理',
        icon: 'md-square',
        access: ['fts_oper_pack']
      },
      component: () => import('@/view/fts/oper/pack/pack-index.vue')
    }, {
      name: 'oper_quality_inspection',
      path: 'oper_quality_inspection',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '质量检测',
        icon: 'md-square',
        access: ['oper_quality_inspection']
      },
      component: () => import('@/view//fts/oper/quality-inspection/quality-inspection-index.vue')
    }, {
      name: 'fts_oper_orderform',
      path: 'fts_oper_orderform',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '订单管理',
        icon: 'md-square',
        access: ['fts_oper_orderform']
      },
      component: () => import('@/view/fts/oper/order_form/orderform-index')
    }]
  },
  {
    name: 'fts_tracing_counterfeiting',
    path: '/fts_tracing_counterfeiting',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: false,
      title: '追溯防伪',
      icon: 'ios-ribbon',
      access: ['fts_tracing_counterfeiting']
    },
    component: Main,
    children: [{
      name: 'fts_tracing_counterfeiting_myback',
      path: 'fts_tracing_counterfeiting_myback',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '我的追溯',
        icon: 'md-square',
        access: ['fts_tracing_counterfeiting_myback']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/myback/myback-list.vue')
    }, {
      name: 'fts_tracing_counterfeiting_generate',
      path: 'fts_tracing_counterfeiting_generate',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '生成记录',
        icon: 'md-square',
        access: ['fts_tracing_counterfeiting_generate']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/generate/generate-list.vue')
    }, {
      name: 'fts_tracing_counterfeiting_activation',
      path: 'fts_tracing_counterfeiting_activation',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '激活记录',
        icon: 'md-square',
        access: ['fts_tracing_counterfeiting_activation']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/activation/activation-list.vue')
    }, {
      name: 'fts_tracing_counterfeiting_print',
      path: 'fts_tracing_counterfeiting_print',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '打印记录',
        icon: 'md-square',
        access: ['fts_tracing_counterfeiting_print']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/print/print-list.vue')
    }, {
      name: 'fts_tracing_counterfeiting_inquiry_record',
      path: 'fts_tracing_counterfeiting_inquiry_record',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '查询记录',
        icon: 'md-square',
        access: ['fts_tracing_counterfeiting_inquiry_record']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/inquiry-record/inquiry-record-index.vue')
    }, {
      name: 'fts_tracing_counterfeiting_trace_evaluation',
      path: 'fts_tracing_counterfeiting_trace_evaluation',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '追溯评价',
        icon: 'md-square',
        access: ['fts_tracing_counterfeiting_trace_evaluation']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/trace-evaluation/trace-evaluation-index.vue')
    }]
  },
  {
    name: 'fts_trace_setting',
    path: '/fts_trace_setting',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '追溯配置',
      icon: 'ios-analytics',
      access: ['fts_trace_setting']
    },
    component: Main,
    children: [{
      name: 'trace_setting_target',
      path: 'trace_setting_target',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '指标配置',
        icon: 'md-square'
      },
      component: () => import('@/view/fts/trace-setting/target/target-index.vue')
    }, {
      name: 'trace_setting_tract_tpl',
      path: 'trace_setting_tract_tpl',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '追溯模板配置',
        icon: 'md-square'
      },
      component: () => import('@/view/fts/trace-setting/trace-tpl/trace-tpl-index.vue')
    }, {
      name: 'trace_setting_trace_code',
      path: 'trace_setting_trace_code',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '追溯码库',
        icon: 'md-square',
        access: ['trace_setting_trace_code']
      },
      component: () => import('@/view/fts/trace-setting/trace-code/trace-code-index.vue')
    }]
  },
  {
    name: 'fts_notice_manage',
    path: '/fts_notice_manage',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: false,
      title: '通知公告',
      icon: 'md-megaphone',
      access: ['fts_notice_manage']
    },
    component: Main,
    children: [{
      name: 'fts_notice',
      path: 'fts_notice',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '通知公告',
        icon: 'md-square',
        access: ['fts_notice']
      },
      component: () => import('@/view/fts/notice/notice-list.vue')
    }]
  },
  {
    name: 'customer_service',
    path: '/customer_service',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: false,
      title: '联系客服',
      icon: 'ios-call',
      access: ['customer_service']
    },
    component: Main,
    children: [{
      name: 'customer-service-index',
      path: 'customer-service-index',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '联系客服',
        icon: 'ios-call',
        access: ['customer-service-index']
      },
      component: () => import('@/view/fts/customer-service/customer-service-index.vue')
    }, {
      name: 'custiner-service-admin-index',
      path: 'custiner-service-admin-index',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '反馈回复',
        icon: 'md-square',
        access: ['custiner-service-admin-index']
      },
      component: () => import('@/view/fts/customer-service/customer-service-admin/customer-service-admin-feedback.vue')
    }, {
      name: 'customer_service_admin_questions',
      path: 'customer_service_admin_questions',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '常见问题',
        icon: 'md-square',
        access: ['customer_service_admin_questions']
      },
      component: () => import('@/view/fts/customer-service/customer-service-admin/customer_service_admin_questions.vue')
    }]
  },
  {
    name: 'fts_trace_code',
    path: '/fts_trace_code',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '追溯码',
      icon: 'md-megaphone',
      access: ['fts_trace_code']
    },
    component: Main,
    children: [{
      name: 'fts_trace_code_apply',
      path: 'fts_trace_code_apply',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '追溯码申请',
        icon: 'md-square',
        access: ['fts_trace_code_apply']
      },
      component: () => import('@/view/fts/tracing-counterfeiting/trace-code-apply/assign-record-index.vue')
    }]
  },
  {
    name: 'fts_template',
    path: '/fts_template',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '追溯宝模板',
      icon: 'ios-list-box',
      access: ['fts_template']
    },
    component: Main,
    children: [{
      name: 'fts_template_management',
      path: 'fts_template_management',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '模板管理',
        icon: 'md-square',
        access: ['fts_template_management']
      },
      component: () => import('@/view/fts/template/template-management/template-management-list.vue')
    }, {
      name: 'fts_equipment_management',
      path: 'fts_equipment_management',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '设备管理',
        icon: 'md-square',
        access: ['fts_equipment_management']
      },
      component: () => import('@/view/fts/template/equipment-management/equipment-management-list.vue')
    }]
  },
  {
    name: 'fts_purchase-manage',
    path: '/fts_purchase-manage',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: false,
      title: '采购管理',
      icon: 'ios-cart',
      access: ['fts_purchase-manage']
    },
    component: Main,
    children: [{
      name: 'fts_purchase',
      path: 'fts_purchase',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '采购管理',
        icon: 'md-square',
        access: ['fts_purchase']
      },
      component: () => import('@/view/fts/purchase/purchase-index.vue')
    }]
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '产品首页',
      hideInMenu: true
    },
    component: () => import('@/view/fts/index/index.vue')
  },
  {
    path: '/intro',
    name: 'intro',
    meta: {
      title: '产品介绍',
      hideInMenu: true
    },
    component: () => import('@/view/fts/index/product-intro.vue')
  },
  {
    path: '/company',
    name: 'company',
    meta: {
      title: '企业介绍',
      hideInMenu: true
    },
    component: () => import('@/view/fts/index/company-info.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    meta: {
      title: '解决方案',
      hideInMenu: true
    },
    component: () => import('@/view/fts/index/solution.vue')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      title: '查询结果',
      hideInMenu: true
    },
    component: () => import('@/view/fts/index/search-result.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      title: '支付中心',
      hideInMenu: true
    },
    component: () => import('@/view/fts/index/pay-center.vue')
  },
  {
    name: 'fts_integrity',
    path: '/fts_integrity',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '诚信体系',
      icon: 'ios-cart',
      access: ['fts_integrity']
    },
    component: Main,
    children: [{
      name: 'fts_integrity_list',
      path: 'fts_integrity_list',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '诚信体系',
        icon: 'md-square',
        access: ['fts_integrity_list']
      },
      component: () => import('@/view/fts/integrity/ftsIntegrity-list.vue')
    }]
  },
  {
    name: 'fts_inspection',
    path: '/fts_inspection',
    meta: {
      hideInMenu: false,
      notCache: false,
      showAlways: true,
      title: '检测信息',
      icon: 'ios-cart',
      access: ['fts_inspection']
    },
    component: Main,
    children: [{
      name: 'fts_inspection_baseinsp',
      path: 'fts_inspection_baseinsp',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '基地检测',
        icon: 'md-square',
        access: ['fts_inspection_baseinsp']
      },
      component: () => import('@/view/fts/inspection/base/base-inspection.vue')
    },{
      name: 'fts_inspection_siteinsp',
      path: 'fts_inspection_siteinsp',
      meta: {
        hideInMenu: false,
        notCache: false,
        showAlways: true,
        title: '服务站检测',
        icon: 'md-square',
        access: ['fts_inspection_site']
      },
      component: () => import('@/view/fts/inspection/site/site-inspection.vue')
    }]
  }
]
export default ftsMenusRouters



// WEBPACK FOOTER //
// ./src/router/routers-menu-fts.js